import FormulateNumberStepper from './FormulateNumberStepper.vue'

export default function VueFormulateNumberStepperPlugin(formulateInstance) {
  formulateInstance.extend({
    components: {
      FormulateNumberStepper,
    },
    library: {
      'number-stepper': {
        classification: 'option',
        component: 'FormulateNumberStepper',
        slotProps: {
          component: ['maxValue', 'invalidOptionMessage'],
        },
      },
    },
  })
}
